import { ArrowDownIcon } from 'assets/icons/arrow-down';
import React from 'react';
import { Link } from 'react-router';
import { cn } from 'utils';

interface SidebarMainItemProps {
  title: string;
  href: string;
  icon: () => JSX.Element;
  isExpanded: boolean;
  isActive: boolean;
  hasSubItems?: boolean;
  onToggle?: () => void;
  onClick?: () => void;
}

const SidebarMainItem: React.FC<SidebarMainItemProps> = ({
  title,
  href,
  icon,
  isExpanded,
  isActive,
  hasSubItems,
  onToggle,
  onClick,
}) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2 py-2 px-4 cursor-pointer justify-between',
        isActive && 'font-medium bg-white shadow-sm rounded-[12px]'
      )}
      onClick={onToggle}
    >
      <Link
        to={href === '' ? '/' : href}
        className="flex items-center gap-2 flex-1"
        onClick={(e) => {
          if (hasSubItems) {
            e.preventDefault();
          } else {
            onClick?.();
          }
        }}
      >
        {icon()}
        <span className="text-[12px]">{title}</span>
      </Link>

      {hasSubItems && (
        <div
          className={cn(
            'transition-transform',
            isExpanded ? 'rotate-180' : 'rotate-0'
          )}
        >
          <ArrowDownIcon />
        </div>
      )}
    </div>
  );
};

export default SidebarMainItem;
